import type { IconName } from '@hotjar/hotsauce';

export enum TARGETING_VALUE {
  EXACT = 'exact',
  CONTAINS = 'contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  SIMPLE = 'simple_match',
  REGEX = 'regex',
}

export const TARGETING_PLACEHOLDERS = {
  [TARGETING_VALUE.EXACT]: 'heatmaps:targeting.exact.placeholder',
  [TARGETING_VALUE.SIMPLE]: 'heatmaps:targeting.simple.placeholder',
  [TARGETING_VALUE.CONTAINS]: 'heatmaps:targeting.contains.placeholder',
  [TARGETING_VALUE.STARTS_WITH]: 'heatmaps:targeting.starts-with.placeholder',
  [TARGETING_VALUE.ENDS_WITH]: 'heatmaps:targeting.ends-with.placeholder',
  [TARGETING_VALUE.REGEX]: 'heatmaps:targeting.regex.placeholder',
};

export const SIMPLE_MATCH_AUTOCOMPLETE_PLACEHOLDER =
  'heatmaps:targeting.simple.autocomplete-placeholder';

export type TargetingOptionValue =
  | 'single_page'
  | 'exact'
  | 'contains'
  | 'starts_with'
  | 'ends_with'
  | 'regex';

export type TargetingOption = {
  icon: IconName;
  label: string;
  value: TargetingOptionValue;
};

export enum TARGETING_OPTION_VALUE {
  SINGLE_PAGE = 'single_page',
  EXACT = 'exact',
  CONTAINS = 'contains',
  STARTS_WITH = 'starts_with',
  ENDS_WITH = 'ends_with',
  REGEX = 'regex',
}

export const TARGETING_VALUE_LABELS = {
  [TARGETING_VALUE.EXACT]: 'heatmaps:targeting.exact.label',
  [TARGETING_VALUE.CONTAINS]: 'heatmaps:targeting.contains.label',
  [TARGETING_VALUE.STARTS_WITH]: 'heatmaps:targeting.starts-with.label',
  [TARGETING_VALUE.ENDS_WITH]: 'heatmaps:targeting.ends-with.label',
  [TARGETING_VALUE.SIMPLE]: 'heatmaps:targeting.simple.label',
  [TARGETING_VALUE.REGEX]: 'heatmaps:targeting.regex.label',
};
